/* eslint-disable max-lines */
import * as c from './types';

import createReducer from '../../reducers/utils/createReducer';

const initialState = {
  data: {},
  isLoading: false,
  isTreeLossesLoading: false,
  isUpdateInProgress: false,
  isCreateInProgress: false,
  isSplitStopLoading: false,
  isDuplicationInProgress: [],
  isDeletionInProgress: [],
  splitStops: [],
  error: null,
  splitStopError: null,
  generalCauses: [],
  specificCauses: [],
  components: [],
  componentList: [],
  componentGroups: [],
  treeLosses: [],
  stopAutomations: null,
  isStopAutomationsLoading: false,
  isBulkCreateInProgress: false,
  failedStopCauses: [],
  machineEquipments: [],
  isMachineEquipmentsLoading: false,
  isStopAutomationCreateInProgress: false,
  isStopAutomationUpdateInProgress: false,
  isStopAutomationDeleteInProgress: false,
  isGeneralCauseCreateInProgress: false,
  isSpecifiCauseCreateInProgress: false,
  isComponentCreateInProgress: false
};

export default createReducer(initialState, {
  [c.GET_STOP_CAUSES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_STOP_CAUSES_SUCCESS]: (state, { payload }) => {
    const { generalCauses, components, specificCauses } = payload;
    return {
      ...state,
      data: payload,
      isLoading: false,
      generalCauses,
      components,
      specificCauses
    };
  },
  [c.GET_STOP_CAUSES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.CREATE_GENERAL_CAUSE_POST]: (state, { payload }) => {
    const index = state.generalCauses.findIndex(
      (generalCause) => generalCause.id === payload.id
    );
    if (index !== -1) {
      const temp = state.generalCauses;
      temp[index].name = payload.name;
      temp[index].programmed = payload.programmed;
      return {
        ...state,
        generalCauses: temp,
        error: null,
        isLoading: false
      };
    }
    return {
      ...state,
      error: null,
      isLoading: true,
      isGeneralCauseCreateInProgress: true
    };
  },
  [c.CREATE_GENERAL_CAUSE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false,
    isGeneralCauseCreateInProgress: false
  }),
  [c.CREATE_GENERAL_CAUSE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    isGeneralCauseCreateInProgress: false
  }),
  [c.CREATE_BULK_GENERAL_CAUSES_POST]: (state) => ({
    ...state,
    isBulkCreateInProgress: true,
    isGeneralCauseCreateInProgress: false
  }),
  [c.CREATE_BULK_GENERAL_CAUSES_SUCCESS]: (state, { payload }) => ({
    ...state,
    failedStopCauses: payload,
    isBulkCreateInProgress: false
  }),
  [c.CREATE_BULK_GENERAL_CAUSES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isBulkCreateInProgress: false
  }),
  [c.CREATE_SPECIFIC_CAUSE_POST]: (state, { payload }) => {
    const index = state.specificCauses.findIndex(
      (specificCause) => specificCause.id === payload.id
    );
    if (index !== -1) {
      const temp = state.specificCauses;
      temp[index].name = payload.name;
      return {
        ...state,
        specificCauses: temp,
        error: null,
        isLoading: false
      };
    }
    return {
      ...state,
      error: null,
      isLoading: true,
      isSpecifiCauseCreateInProgress: true
    };
  },
  [c.CREATE_SPECIFIC_CAUSE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false,
    isSpecifiCauseCreateInProgress: false
  }),
  [c.CREATE_SPECIFIC_CAUSE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    isSpecifiCauseCreateInProgress: false
  }),
  [c.CREATE_BULK_SPECIFIC_CAUSES_POST]: (state) => ({
    ...state,
    isBulkCreateInProgress: true
  }),
  [c.CREATE_BULK_SPECIFIC_CAUSES_SUCCESS]: (state, { payload }) => ({
    ...state,
    failedStopCauses: payload,
    isBulkCreateInProgress: false
  }),
  [c.CREATE_BULK_SPECIFIC_CAUSES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isBulkCreateInProgress: false
  }),
  [c.CREATE_COMPONENT_POST]: (state, { payload }) => {
    const index = state.components.findIndex(
      (component) => component.id === payload.id
    );
    if (index !== -1) {
      const temp = state.components;
      temp[index].name = payload.name;
      return {
        ...state,
        components: temp,
        error: null,
        isLoading: false
      };
    }
    return {
      ...state,
      error: null,
      isLoading: true,
      isComponentCreateInProgress: true
    };
  },
  [c.CREATE_COMPONENT_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false,
    isComponentCreateInProgress: false
  }),
  [c.CREATE_COMPONENT_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    isComponentCreateInProgress: false
  }),

  [c.DELETE_GENERAL_CAUSE_POST]: (state, { payload }) => {
    const generalCauses = state.generalCauses.filter((generalCause) =>
      payload.ids
        ? !payload.ids.includes(generalCause.id)
        : generalCause.id !== payload.id
    );
    return {
      ...state,
      error: null,
      isLoading: false,
      generalCauses
    };
  },
  [c.DELETE_GENERAL_CAUSE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.DELETE_GENERAL_CAUSE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.DELETE_SPECIFIC_CAUSE_POST]: (state, { payload }) => {
    const specificCauses = state.specificCauses.filter((specificCause) =>
      payload.ids
        ? !payload.ids.includes(specificCause.id)
        : specificCause.id !== payload.id
    );
    return {
      ...state,
      error: null,
      isLoading: false,
      specificCauses
    };
  },
  [c.DELETE_SPECIFIC_CAUSE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.DELETE_SPECIFIC_CAUSE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.DELETE_COMPONENT_POST]: (state, { payload }) => {
    const components = state.components.filter((component) =>
      payload.ids
        ? !payload.ids.includes(component.id)
        : component.id !== payload.id
    );
    return {
      ...state,
      error: null,
      isLoading: false,
      components
    };
  },
  [c.DELETE_COMPONENT_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.DELETE_COMPONENT_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.GET_TREE_LOSSES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isTreeLossesLoading: true
  }),
  [c.GET_TREE_LOSSES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      treeLosses: payload,
      isTreeLossesLoading: false,
      isDuplicationInProgress: new Array(payload.length).fill(false),
      isDeletionInProgress: new Array(payload.length).fill(false)
    };
  },
  [c.GET_TREE_LOSSES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isTreeLossesLoading: false
  }),
  [c.GET_COMPONENT_LIST_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_COMPONENT_LIST_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      data: payload,
      componentList: payload,
      isLoading: false
    };
  },
  [c.GET_COMPONENT_LIST_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.UPDATE_COMPONENT_LIST_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.UPDATE_COMPONENT_LIST_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      data: payload,
      componentList: payload.data,
      isLoading: false
    };
  },
  [c.UPDATE_COMPONENT_LIST_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.DELETE_COMPONENT_LIST_POST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.DELETE_COMPONENT_LIST_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    componentList: state.componentList.filter((l) => l.id !== payload.id),
    isLoading: false
  }),
  [c.DELETE_COMPONENT_LIST_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.ADD_COMPONENT_GROUP]: (state, { payload }) => {
    const newComponentGroups = [...state.componentGroups];
    newComponentGroups.push(payload.componentGroup);
    return {
      ...state,
      componentGroups: newComponentGroups
    };
  },
  [c.ADD_TREE_LOSS]: (state, { payload }) => {
    const newTreeLosses = [...state.treeLosses];
    newTreeLosses.push(payload.treeLoss);
    return {
      ...state,
      treeLosses: newTreeLosses
    };
  },
  [c.DELETE_COMPONENT_GROUP]: (state, { payload }) => {
    const newComponentGroups = state.componentGroups.filter(
      (curr) => curr.name !== payload.componentGroup.name
    );
    return {
      ...state,
      componentGroups: newComponentGroups
    };
  },
  [c.DELETE_TREE_LOSS_REQUEST]: (state, { payload }) => {
    const newState = { ...state, error: null };
    newState.isDeletionInProgress[payload.index] = true;
    return newState;
  },
  [c.DELETE_TREE_LOSS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      error: null,
      treeLosses: state.treeLosses.filter((e) => e.id !== payload.id),
      isDeletionInProgress: new Array(state.treeLosses.length - 1).fill(false),
      isDuplicaionInProgress: new Array(state.treeLosses.length - 1).fill(false)
    };
  },
  [c.DELETE_TREE_LOSS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isDeletionInProgress: new Array(state.data.length).fill(false)
  }),
  [c.UPDATE_COMPONENT_GROUP]: (state, { payload }) => {
    const newComponentGroups = [...state.componentGroups];
    const index = newComponentGroups.findIndex(
      (curr) => curr.name === payload.componentGroup.name
    );
    if (index !== -1) {
      newComponentGroups[index] = payload.componentGroup;
    }
    return {
      ...state,
      componentGroups: newComponentGroups
    };
  },
  [c.UPDATE_TREE_LOSS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isUpdateInProgress: true
  }),
  [c.UPDATE_TREE_LOSS_SUCCESS]: (state, { payload }) => {
    const newTreeLosses = [...state.treeLosses];
    const index = newTreeLosses.findIndex((curr) => curr.id === payload.id);
    if (index !== -1) {
      newTreeLosses[index] = payload;
    }
    return {
      ...state,
      treeLosses: newTreeLosses,
      isUpdateInProgress: false
    };
  },
  [c.UPDATE_TREE_LOSS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isUpdateInProgress: false
  }),
  [c.CREATE_TREE_LOSS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isCreateInProgress: true
  }),
  [c.CREATE_TREE_LOSS_SUCCESS]: (state, { payload }) => {
    const newTreeLosses = [...state.treeLosses];
    newTreeLosses.push(payload);
    return {
      ...state,
      treeLosses: newTreeLosses,
      isCreateInProgress: false,
      isDuplicationInProgress: new Array(state.treeLosses.length + 1).fill(
        false
      ),
      isDeletionInProgress: new Array(state.treeLosses.length + 1).fill(false)
    };
  },
  [c.CREATE_TREE_LOSS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isCreateInProgress: false
  }),
  [c.DUPLICATE_TREE_LOSS_REQUEST]: (state, { payload }) => {
    const newState = { ...state, error: null };
    newState.isDuplicationInProgress[payload.index] = true;
    return newState;
  },
  [c.DUPLICATE_TREE_LOSS_SUCCESS]: (state, { payload }) => {
    const newTreeLosses = [...state.treeLosses];
    newTreeLosses.push(payload);
    return {
      ...state,
      treeLosses: newTreeLosses,
      isCreateInProgress: false,
      isDuplicationInProgress: new Array(state.treeLosses.length + 1).fill(
        false
      ),
      isDeletionInProgress: new Array(state.treeLosses.length + 1).fill(false)
    };
  },
  [c.DUPLICATE_TREE_LOSS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isDuplicaionInProgress: new Array(state.treeLosses.length).fill(false)
  }),
  [c.UPDATE_TREE_LOSS_MACHINE_REQUEST]: (state) => ({
    ...state
  }),
  [c.UPDATE_TREE_LOSS_MACHINE_SUCCESS]: (state) => ({
    ...state
  }),
  [c.UPDATE_TREE_LOSS_MACHINE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.DELETE_TREE_LOSS_MACHINE_REQUEST]: (state) => ({
    ...state
  }),
  [c.DELETE_TREE_LOSS_MACHINE_SUCCESS]: (state) => ({
    ...state
  }),
  [c.DELETE_TREE_LOSS_MACHINE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.UPDATE_FAILED_STOP_CAUSES]: (state, { payload }) => ({
    ...state,
    failedStopCauses: payload.failedStopCauses
  }),
  [c.GET_MACHINE_EQUIPMENTS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isMachineEquipmentsLoading: true
  }),
  [c.GET_MACHINE_EQUIPMENTS_SUCCESS]: (state, { payload }) => {
    const machineEquipments = [];
    for (const machineEquipment of payload) {
      const index = machineEquipments.findIndex(
        (curr) => curr.machineId === machineEquipment.machineId
      );
      if (index !== -1) {
        machineEquipments[index].equipments.push({
          id: machineEquipment.componentId,
          name: machineEquipment.componentName
        });
      } else {
        machineEquipments.push({
          machineId: machineEquipment.machineId,
          equipments: [
            {
              id: machineEquipment.componentId,
              name: machineEquipment.componentName
            }
          ]
        });
      }
    }
    return {
      ...state,
      machineEquipments,
      isMachineEquipmentsLoading: false
    };
  },
  [c.GET_MACHINE_EQUIPMENTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isMachineEquipmentsLoading: false
  }),
  [c.UPDATE_MACHINE_EQUIPMENTS_REQUEST]: (state) => ({
    ...state
  }),
  [c.UPDATE_MACHINE_EQUIPMENTS_SUCCESS]: (state) => ({
    ...state
  }),
  [c.UPDATE_MACHINE_EQUIPMENTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload
  }),
  [c.CREATE_BULK_EQUIPMENTS_POST]: (state) => ({
    ...state,
    isBulkCreateInProgress: true
  }),
  [c.CREATE_BULK_EQUIPMENTS_SUCCESS]: (state, { payload }) => ({
    ...state,
    failedStopCauses: payload,
    isBulkCreateInProgress: false
  }),
  [c.CREATE_BULK_EQUIPMENTS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isBulkCreateInProgress: false
  }),
  [c.GET_STOP_AUTOMATIONS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isStopAutomationsLoading: true
  }),
  [c.GET_STOP_AUTOMATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      stopAutomations: payload,
      isStopAutomationsLoading: false
    };
  },
  [c.GET_STOP_AUTOMATIONS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isStopAutomationsLoading: false
  }),
  [c.CREATE_STOP_AUTOMATION_REQUEST]: (state) => ({
    ...state,
    isStopAutomationCreateInProgress: true
  }),
  [c.CREATE_STOP_AUTOMATION_SUCCESS]: (state) => ({
    ...state,
    isStopAutomationCreateInProgress: false
  }),
  [c.CREATE_STOP_AUTOMATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isStopAutomationCreateInProgress: false
  }),
  [c.UPDATE_STOP_AUTOMATION_REQUEST]: (state, { payload }) => {
    const newState = { ...state };
    const index = newState.stopAutomations.findIndex(
      (e) => e.id === payload.stopAutomationId
    );
    if (index !== -1) {
      const stopAutomation = { ...newState.stopAutomations[index] };
      if (payload.isActive !== undefined)
        stopAutomation.isActive = payload.isActive;
      newState.stopAutomations[index] = stopAutomation;
      newState.isStopAutomationUpdateInProgress = true;
    }
    return newState;
  },
  [c.UPDATE_STOP_AUTOMATION_SUCCESS]: (state) => ({
    ...state,
    isStopAutomationUpdateInProgress: false
  }),
  [c.UPDATE_STOP_AUTOMATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isStopAutomationUpdateInProgress: false
  }),
  [c.DELETE_STOP_AUTOMATION_REQUEST]: (state) => ({
    ...state,
    isStopAutomationDeleteInProgress: true
  }),
  [c.DELETE_STOP_AUTOMATION_SUCCESS]: (state) => ({
    ...state,
    error: null,
    isStopAutomationDeleteInProgress: false
  }),
  [c.DELETE_STOP_AUTOMATION_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isStopAutomationDeleteInProgress: false
  }),
  [c.SPLIT_STOP_REQUEST]: (state) => ({
    ...state,
    isSplitStopLoading: true
  }),
  [c.SPLIT_STOP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      splitStops: payload.newStops.map((x) => x.id),
      isSplitStopLoading: false,
      splitStopError: null
    };
  },
  [c.SPLIT_STOP_ERROR]: (state, { payload }) => ({
    ...state,
    splitStopError: payload,
    isSplitStopLoading: false
  }),
  [c.CLEAR_SPLIT_STOPS]: (state, { payload }) => {
    return {
      ...state,
      splitStops: payload
    };
  },
  [c.SET_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS]: (state, { payload }) => {
    const specificCauses = [...state.specificCauses];
    const itemIndex = specificCauses.findIndex(
      (x) => x.id === payload.subjectId
    );
    specificCauses[itemIndex].Tags?.push({
      id: '',
      tagKey: 'Programmed',
      tagValue: 'P'
    });

    return {
      ...state,
      specificCauses
    };
  },
  [c.SET_NOT_PROGRAMMED_SPECIFIC_CAUSE_SUCCESS]: (state, { payload }) => {
    const specificCauses = [...state.specificCauses];
    const itemIndex = specificCauses.findIndex(
      (x) => x.id === payload.subjectId
    );
    specificCauses[itemIndex].Tags = specificCauses[itemIndex].Tags?.filter(
      (x) => x.tagKey !== 'Programmed' && x.tagValue !== 'P'
    );

    return {
      ...state,
      specificCauses
    };
  },
  [c.GET_STOP_SPECIFIC_CAUSES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      specificCauses: payload
    };
  }
});
